module.exports = __webpack_public_path__ + "img/ico_actualizar.0fe371d9.svg";